
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ISocialMediaItem, IconComponent, LinkDirective } from '@sirius/common';
@Component({
    selector: 'ur-social-media-links',
    templateUrl: './social-media-links.component.html',
    styleUrl: './social-media-links.component.scss',
    imports: [IconComponent, LinkDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialMediaLinksComponent {
    private static nextId = 0;
    readonly labelId = `ur-social-media-links-label-${SocialMediaLinksComponent.nextId++}`;

    @Input() title? = '';
    @Input() socialMediaLinks: ISocialMediaItem[] = [];

    get socialMediaLinksWithIcon(): Array<
        ISocialMediaItem & { icon: NonNullable<ISocialMediaItem['icon']> }
    > {
        return this.socialMediaLinks.filter(
            (item): item is ISocialMediaItem & { icon: NonNullable<ISocialMediaItem['icon']> } =>
                Boolean(item.icon),
        );
    }
}
